// extracted by mini-css-extract-plugin
export var menuItem = "G_vN d_fZ d_bz d_bD d_bP d_bf";
export var menuItemSub = "G_vP d_Z d_bz d_bP";
export var menuMainLink = "G_vQ d_f0 d_dB";
export var menuLink = "G_vR d_f0 d_dB";
export var icon = "G_n9 d_bC d_bP";
export var divider = "G_vS d_bC d_bP";
export var sublinks = "G_vT";
export var link = "G_mC";
export var Link = "G_tx y_tx y_sL y_s4";